import type { FC } from 'react'

import { FoundEntitiesList } from './FoundEntitiesList'
import { FoundSubEntitiesTable } from './FoundSubEntitiesTable'
import css from './SearchResultsContent.css'
import type { SearchResultsPanelProps as Props } from './types'

export const SearchResultsContent: FC<Props> = ({ projectId, addCrmsFiles, addGeoDFiles }) => {
  return (
    <div className={css.container}>
      <FoundEntitiesList projectId={projectId} />
      <div className={css.resultsTable}>
        <FoundSubEntitiesTable addCrmsFiles={addCrmsFiles} addGeoDFiles={addGeoDFiles} />
      </div>
    </div>
  )
}
